import { render, staticRenderFns } from "./OrderRefundForm.vue?vue&type=template&id=53a0e834&scoped=true"
import script from "./OrderRefundForm.vue?vue&type=script&lang=js"
export * from "./OrderRefundForm.vue?vue&type=script&lang=js"
import style0 from "./OrderRefundForm.vue?vue&type=style&index=0&id=53a0e834&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a0e834",
  null
  
)

export default component.exports